import createAxiosInstance from 'src/utils/createAxiosInstance ';
import { CLIENT_PORTAL_API_URL, EMPLOYER_HUB_API_URL } from 'src/utils/constants';

export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const employerHubApi = createAxiosInstance(EMPLOYER_HUB_API_URL);
